/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import Editor from '../../../../../components/editor/Editor';
import ImageWithErrorHandling from '../../../../../components/image/ImageWithErrorHandling';
import { ImageSelect } from '../../../../../components/inputs/ImageSelect';
import { FormSelect } from '../../../../../components/tables/filterForms/FormSelect';
import { useDataContext } from '../../../../../context';
import { quoteTypes } from '../../../../../utils/consts/website/quotes';
import { StepProps } from './AddEditTeamProfile';

export const TeamProfileForm = ({ touched, errors, values, setFieldValue, readOnly }: StepProps) => {
  const { locationOptions } = useDataContext();

  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Team Profile Details" showRequiredLegend={!readOnly} />
        </Col>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="name"
          >
            <FormLabel required>Name</FormLabel>
            <Field
              name="name"
              as={Form.Control}
              isInvalid={touched.name && !!errors.name}
              aria-required
            />
            <ErrorMessage name="name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="title"
          >
            <FormLabel required>Title</FormLabel>
            <Field
              name="title"
              as={Form.Control}
              isInvalid={touched.title && !!errors.title}
              aria-required
            />
            <ErrorMessage name="title">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="location_id"
          >
            <Field
              name="location_id"
              as={FormSelect}
              label="Location"
              options={locationOptions}
              required
              isInvalid={touched.location_id && !!errors.location_id}
            />
            <ErrorMessage name="location_id">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="is_hq"
          >
            <Field
              name="is_hq"
              checked={values?.is_hq}
              as={Form.Check}
              label="Is HQ"
              isInvalid={touched.is_hq && !!errors.is_hq}
            />
            <ErrorMessage name="is_hq">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="description"
          >
            <FormLabel required>Description</FormLabel>
            <Field
              name="description"
              component={Editor}
              isInvalid={touched.description && !!errors.description}
              aria-required
            />
            <ErrorMessage name="description">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="quote_type"
          >
            <FormLabel required>Quote Type</FormLabel>
            <Field
              name="quote_type"
              as={Form.Select}
              isInvalid={touched.quote_type && !!errors.quote_type}
              aria-required
            >
              <option>Select</option>
              {Object.entries(quoteTypes).map((type, idx) => (
                <option
                  key={idx}
                  value={type[0]}
                >
                  {type[1]}
                </option>
              ))}
            </Field>
            <ErrorMessage name="quote_type">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="quote"
          >
            <FormLabel required>Quote</FormLabel>
            <Field
              name="quote"
              as={Form.Control}
              isInvalid={touched.quote && !!errors.quote}
              aria-required
            />
            <ErrorMessage name="quote">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="image"
          >
            <ImageSelect
              label={`Image${values?.image_file_name ? ` (${values?.image_file_name})` : ''}`}
              name="image"
              onChange={setFieldValue}
            />
            {values?.s3_base_url && values?.image_file_name && (
              <ImageWithErrorHandling
                src={`${values.s3_base_url}/${values.image_file_name}`}
                alt={values.image_file_name}
              />
            )}
            <ErrorMessage name="image">
              {(msg) => (
                <FormControl.Feedback type="invalid">
                  {JSON.stringify(msg, null, 2)}
                </FormControl.Feedback>
              )}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
